//# sourceMappingURL=failable.mjs.map
/// <reference types="./failable.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $calendar from "../../gleam_time/gleam/time/calendar.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $json_ from "../../tiamat/gleam/json_.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../gleam.mjs";

export class Success extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Failable$Success = ($0) => new Success($0);
export const Failable$isSuccess = (value) => value instanceof Success;
export const Failable$Success$0 = (value) => value[0];

export class Errored extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Failable$Errored = ($0) => new Errored($0);
export const Failable$isErrored = (value) => value instanceof Errored;
export const Failable$Errored$0 = (value) => value[0];

export class Pending extends $CustomType {
  constructor(expires_at) {
    super();
    this.expires_at = expires_at;
  }
}
export const Failable$Pending = (expires_at) => new Pending(expires_at);
export const Failable$isPending = (value) => value instanceof Pending;
export const Failable$Pending$expires_at = (value) => value.expires_at;
export const Failable$Pending$0 = (value) => value.expires_at;

export function from_result(res) {
  if (res instanceof Ok) {
    let data = res[0];
    return new Success(data);
  } else {
    let err = res[0];
    return new Errored(err);
  }
}

export function to_result(failable) {
  if (failable instanceof Success) {
    let data = failable[0];
    return new Ok(data);
  } else if (failable instanceof Errored) {
    let err = failable[0];
    return new Error(err);
  } else {
    let expires_at = failable.expires_at;
    return new Error($timestamp.to_rfc3339(expires_at, $calendar.utc_offset));
  }
}

export function map(failable, next) {
  if (failable instanceof Success) {
    let a = failable[0];
    return new Success(next(a));
  } else if (failable instanceof Errored) {
    return failable;
  } else {
    return failable;
  }
}

export function then$(failable, next) {
  if (failable instanceof Success) {
    let a = failable[0];
    return next(a);
  } else if (failable instanceof Errored) {
    return failable;
  } else {
    return failable;
  }
}

export function to_json(failable, next) {
  if (failable instanceof Success) {
    let data = failable[0];
    return $json.object(
      toList([
        ["type", $json.string("failable")],
        ["state", $json.string("success")],
        ["content", next(data)],
      ]),
    );
  } else if (failable instanceof Errored) {
    let err = failable[0];
    return $json.object(
      toList([
        ["type", $json.string("failable")],
        ["state", $json.string("errored")],
        ["content", $json.string(err)],
      ]),
    );
  } else {
    let expires_at = failable.expires_at;
    return $json.object(
      toList([
        ["type", $json.string("failable")],
        ["state", $json.string("pending")],
        ["expires_at", $json_.to_rfc3339(expires_at)],
      ]),
    );
  }
}

export function decoder(content) {
  return $decode.field(
    "type",
    $decode.string,
    (type_) => {
      return $decode.field(
        "state",
        $decode.string,
        (state) => {
          if (type_ === "failable") {
            if (state === "success") {
              return $decode.field(
                "content",
                content,
                (content) => { return $decode.success(new Success(content)); },
              );
            } else if (state === "errored") {
              return $decode.field(
                "content",
                $decode.string,
                (err) => { return $decode.success(new Errored(err)); },
              );
            } else if (state === "pending") {
              return $decode.field(
                "expires_at",
                $decrypt.timestamp(),
                (expires_at) => {
                  return $decode.success(new Pending(expires_at));
                },
              );
            } else {
              return $decode.failure(
                new Pending($timestamp.system_time()),
                "Failable",
              );
            }
          } else {
            return $decode.failure(
              new Pending($timestamp.system_time()),
              "Failable",
            );
          }
        },
      );
    },
  );
}
